module.exports = __webpack_public_path__ + "img/kerberos.ad62afc2.svg";